import { breakpoints } from '../components/breakpoints';

export default function group() {
  // Fix z index on groups
  const $groups = $('.main > .wp-block-sage-group, .main > .wp-block-columns');
  let zIndex = $groups.length + 1;
  $groups.each(function () {
    $(this).css('z-index', zIndex);
    zIndex -= 1;
  });

  // Desktop background image
  function setBackgroundImage() {
    $('.wp-block-group__background[data-desktop-bg]').each(function () {
      const bg = $(this).attr('data-bg');
      const desktopBg = $(this).attr('data-desktop-bg');
      if ($(window).width() >= breakpoints.md) {
        $(this).css('background-image', `url(${desktopBg})`);
      } else {
        $(this).css('background-image', `url(${bg})`);
      }
    });
  }

  $(window).resize(function () {
    setBackgroundImage();
  });
  setBackgroundImage();
}
